export default (e: any): any => e.target.value;
